<template>
    <v-card :elevation="elevationProp">
        <v-card-title primary-title>
            <v-row>
                <v-col cols="12" align="start">
                    <div
                        v-if="$vuetify.breakpoint.mdAndDown"
                        class="primary--text text-overline text-center"
                    >
                        Comunicados
                    </div>
                    <div
                        v-else
                        class="
                            font-weight-light
                            primary--text
                            text-h5 text-capitalize
                            mt-n1
                        "
                    >
                        <v-icon large> mdi-email-newsletter </v-icon>
                        Comunicados
                    </div>
                </v-col>
            </v-row>
        </v-card-title>
        <v-data-table
            :headers="headers"
            :items="filteredCommunicates"
            class="elevation-0"
            :search="search"
            :footer-props="footer_props"
            :item-class="itemClass"
        >
            <template v-slot:top>
                <v-text-field
                    v-model="search"
                    label="Buscar"
                    class="mx-4"
                ></v-text-field>
            </template>
            <template v-slot:item.readReceivers="{ item }">
                <v-icon right size="22" v-if="!isRead(item.readReceivers)"
                    >mdi-email-multiple</v-icon
                >
                <v-icon right size="22" v-else>mdi-email-open-multiple</v-icon>
            </template>
            <template v-slot:item.Actions="{ item }">
                <v-col md="12">
                    <div class="d-flex flex-row justify-space-between">
                        <v-icon size="22" @click="openWatch(item)">
                            mdi-location-enter
                        </v-icon>
                    </div>
                </v-col>
            </template>
        </v-data-table>

        <CommunicatesForm />
    </v-card>
</template>

<script>
import { clone, objectSnakeToCamelCase } from '@/util/libUtil.js';
import CommunicatesForm from '@/components/RRHH/Communicates/CommunicatesForm.vue';

export default {
    name: 'CommercialCommunicate',
    data: () => ({
        filteredCommunicates: [],
        search: '',
        headers: [
            {
                text: 'Autor',
                value: 'sender.nombreCompleto',
                align: 'start',
            },
            {
                text: 'Título',
                value: 'messageTitle',
                align: 'start',
            },
            {
                text: 'Estado',
                value: 'readReceivers',
                align: 'start',
            },
            {
                text: 'Ver',
                value: 'Actions',
                align: 'center',
                width: '10px',
                align: 'center',
                sortable: false,
            },
        ],
        footer_props: {
            disableItemsPerPage: true,
            itemsPerPageOptions: [10],
        },
    }),
    components: {
        CommunicatesForm,
    },
    props: {
        elevationProp: null,
    },
    methods: {
        isRead(receivers) {
            return receivers.some(
                (receiver) =>
                    receiver.isRead && receiver.account.id == this.cuenta.id
            );
        },
        itemClass(item) {
            switch (item.priority) {
                case 'LOW':
                    return 'lighten-yellow-bg';
                case 'MIDDLE':
                    return 'lighten-orange-bg';
                case 'HIGH':
                    return 'lighten-red-bg';
                default:
                    return '';
            }
        },
        async openWatch(item) {
            let receivers = [];
            console.log(item);
            item.readReceivers.forEach((receiver) => {
                receivers.push(receiver.account);
            });

            let editingCommunicate = {
                message_body: item.messageBody,
                message_title: item.messageTitle,
                receivers: clone(objectSnakeToCamelCase(receivers)),
                priority: item.priority,
            };

            await this.$store.dispatch('rrhh/setReadCommunicate', {
                id: item.id,
            });
            await this.$store.dispatch('rrhh/fetchCommunicates', {
                created_on: new Date().toISOString().slice(0, 10),
                receivers: this.cuenta.id,
            });
            this.$store.commit('rrhh/communicatesType', 'EDIT');
            this.$store.commit('rrhh/communicatesForm', editingCommunicate);
            this.$store.commit('rrhh/isOpenCommunicateView', true);
            this.filterCommunicates();
        },
        filterCommunicates() {
            let accountFilter = (receiver) =>
                this.elevationProp != '12'
                    ? receiver.account.id == this.cuenta.id
                    : true;
            let isRead = (receiver) =>
                this.elevationProp != '12' ? !receiver.isRead : true;

            this.filteredCommunicates = this.communicates().filter(
                (communicate) =>
                    communicate.readReceivers.some((receiver) =>
                        accountFilter(receiver)
                    )
            );
        },
        communicates() {
            return JSON.parse(localStorage.getItem('communicates'));
        },
    },
    computed: {
        cuenta() {
            return JSON.parse(localStorage.getItem('cuenta'));
        },
    },
    beforeMount() {
        this.$store.dispatch('rrhh/fetchCommunicates', {
            created_on: new Date().toISOString().slice(0, 10),
            receivers: this.cuenta.id,
        });
        this.filterCommunicates();
    },
    beforeUpdate() {
        this.filterCommunicates();
    },
    mounted() {
        this.filterCommunicates();
    },
};
</script>

<style>
.lighten-red-bg {
    background-color: #ffcdd2 !important;
}
.lighten-orange-bg {
    background-color: #fdcb81 !important;
}
.lighten-yellow-bg {
    background-color: #f9ff9e !important;
}
</style>